module.exports = __webpack_public_path__ + "media/images/payments/payoneer-56b833cd572459ac7f738b4d55fd8488.svg";